// extracted by mini-css-extract-plugin
export default {"font-renta":"GlobalNotificationSettings_font-renta__zDzdj"};